<template>
  <div class="market-table-wrap">
    <ul class="market-tab" v-if="config.tabList && config.tabList.length">
      <li
        v-for="(tab, index) in config.tabList"
        :key="index"
        :class="{active: tab.value === config.currentTab}"
        @click="config.currentTab = tab.value"
      >{{tab.name}}</li>
      <div class="title-right">
        <slot name="title-right"></slot>
      </div>
    </ul>
    <div class="overflow" style="overflow-x:auto;">
      <div class="overflow-wrap">
        <ul class="market-table table-head">
          <li>
            <div
              v-for="(head, index) in config.tableHeads"
              :key="index"
              class="light small font-1r"
              :style="{'min-width': head.minWidth, 'justify-content': head.alignment}"
            >
              {{head.name}}
              <span v-if="head.sort" @click="switchSortType(head)">
                <img
                  :src="require(`@/assets/images/home/filtter_arrow_down${head.sortType === 'up' ? '_a' : ''}.png`)"
                  alt
                />
                <img
                  :src="require(`@/assets/images/home/filtter_arrow_down${head.sortType === 'down' ? '_a' : ''}.png`)"
                  alt
                />
              </span>
            </div>
          </li>
        </ul>
        <ul class="market-table table-body">
          <li class="no-data" v-if="!config.dataList || config.dataList.length<=0">{{ $t('common.noRecords') }}</li>
          <li v-for="(data, index) in config.dataList" :key="index">
            <div class="market-table-row">
              <div v-for="(head, index) in config.tableHeads" :key="index" :style="{'min-width': head.minWidth}">
                <slot :data="{conf: data, col: head,}"></slot>
              </div>
            </div>
            <div class="table-toggle" :style="{'display': (data.recharge || data.withdraw) ? '' : 'none' }">
              <slot :data="data" name="toggle"></slot>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GTable',
  components: {},
  props: ['config'],
  data() {
    return {
      currentTab: 'GRX',
    };
  },
  mounted() {
  },
  methods: {
    switchSortType(head) {
      const map = {
        up: 'down',
        down: '',
        default: 'up',
      };
      head.sortType = map[head.sortType || 'default'];
    },
  },
};
</script>
<style scoped>
ul.market-table {
  padding-left: 0;
}
.market-table > li.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 180px;
  font-size: 16px;
  color: rgba(138, 144, 154, 1);
}
.title-right {
  flex: 1 1 0px;
}
.market-table > li .table-toggle {
  /* flex: 0 0 100%; */
  background-color: #fff;
  border-radius: 0 0 4px 4px;
}
.market-table > li .table-toggle > * {
  border-top: 1px solid rgba(230, 234, 240, 1);
}
.market-table-wrap {
  background-color: #fff;
  border-radius: 2px;
  overflow: hidden;
  border: 1px solid rgba(230, 234, 240, 1);
}
.market-tab {
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid rgba(230, 234, 240, 1);
  position:relative;
}
.market-tab > li {
  padding: 0 20px;
  font-size: 16px;
  font-weight: bold;
  line-height: 70px;
  color: #666;
  cursor: pointer;
}
.market-tab > li.active {
  color: #333;
}
.table-head {
  user-select: none;
  border-bottom: 1px solid rgba(230, 234, 240, 1);
  font-weight: bold;
}
.table-head > li > div {
  white-space: nowrap;
}
.market-table > li {
  font-size: 16px;
  color: #8a909a;
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #fff;
}
.market-table.table-body li {
  flex-wrap: wrap;
}
.market-table .market-table-row {
  font-size: 16px;
  color: #8a909a;
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #fff;
  width: 100%;
}
.market-table .market-table-row > div {
  width: 100%;
  padding: 0 22px;
}
.table-head > li {
  color: #333333;
}
.market-table > li:hover {
  background: rgba(230, 234, 240, 0.1);
}
.market-table > li > div:not(.table-toggle):not(.market-table-row) {
  padding: 0 22px;
  /* flex: 1 1 0px; */
  display: flex;
  width: 100%;
  word-break: break-all;
}
.market-table > li:not(:last-child) {
  border-bottom: 1px solid rgba(230, 234, 240, 1);
}
.table-head span {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.table-head span:first-child {
  line-height: 40px;
}
.table-head span:last-child {
  padding: 0 6px;
  cursor: pointer;
}
.table-head span:last-child img {
  margin: 1px 0;
}
.table-head span:last-child img:first-child {
  transform: rotate(180deg);
}
.overflow-wrap {
  min-width: 820px;
}
</style>
